const homeData = [{
  data: ['创力-1.png',
    '东风商用车-1.png',
    '菏泽市人民政府-1.png',
    '华能-1.png',
    '九芝堂-1.png',
    '聚光-1.png',
    '柯马-1.png',
    '上海航天-1.png',
    '索普-1.png',
    '太极-1.png',
    '维达-1.png',
    '延华智能-1.png',
    '扬翔-1.png',
    '移动-1.png',
    '中国电科-1.png',
  ]
}
// {
//  data: ['创力-1.png']
// }
];

const homeData1 = [{
  data: ['', '']
}];

export {
  homeData,
  homeData1
};
